/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoYearPicker {
        restrict = "E";
        scope = {
            name: "@",
            ngModel: "=ngModel",
            disabled: "=ngDisabled",
            change: "&ngChange",
            required: "=ngRequired",
            tabIndex: "=?",
            endingYear:"=?"
        };

        require = "ngModel";

        templateUrl = "app/components/controls/yearPickerTemplate.html";

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            scope.resolvedYearText = this.$translate.instant("LABEL_YEAR");
            scope.getYearNumbers = function (): number[] {
                var currentYear = new Date().getFullYear();
                var years = [];
                var startYear = currentYear;

                var endingYear = parseInt(scope.endingYear);
                if (isNaN(endingYear)) {
                    endingYear = currentYear - 100;
                }
                for (var i = currentYear; i >= endingYear; i--) {
                    years.push(i);
                }

                return years;
            }
        }

        constructor(private $translate: angular.translate.ITranslateService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($translate) => {
                return new MeevoYearPicker($translate);
            };

            directive.$inject = ["$translate"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoYearPicker", MeevoYearPicker.factory());

}